module.exports = __webpack_public_path__ + "img/square_header_2new.8439884f.png";